import React, { useEffect, useState } from 'react'
import constants from 'utils/constants';
const KakaoShareButton = ({kakaoButton,queryString, shareTitle, shareDescription, shareImg}) => {

  const [currUrl, setCurrUrl] = useState('https://motiners.com');
  const [title, setTitle] = useState('모티너스');
  const [description, setDescription] = useState('');
  const [imageUrl, setImageUrl] = useState(`${constants.imagePath}/common/banner_img/motiners_common_banner-1125x672.png`);

  useEffect(() => { 
    if(shareTitle)
    {
      setTitle(shareTitle);
    }
    if(shareDescription)
    {
      setDescription(shareDescription);
    }
    if(shareImg)
    {
      setImageUrl(shareImg);
    }
  }, [queryString, shareTitle, shareDescription, shareImg])
  useEffect(() => {
    setCurrUrl(window.location.href);  
    //createKakaoButton();
  }, [queryString])

  let handleClick = (e) => {
    let queryStringAttr = e.currentTarget.getAttribute('data-query-string');
    if (window.Kakao) {
      const kakao = window.Kakao
      // 중복 initialization 방지
      if (!kakao.isInitialized()) {
        // 두번째 step 에서 가져온 javascript key 를 이용하여 initialize
        kakao.init("9f3d0034d8d6dc3aa8bcf87c3f74d49e")
      }

      let linkQuery = (queryStringAttr)? `?${queryStringAttr}`: '';

      let linkUrl = currUrl +`${linkQuery}`;
      kakao.Link.createDefaultButton({
        // Render 부분 id=kakao-link-btn 을 찾아 그부분에 렌더링을 합니다
        container: '#kakao-link-btn',
        objectType: 'feed',
        content: {
          title: title,
          description: description,
          imageUrl: imageUrl , // i.e. process.env.FETCH_URL + '/logo.png' 'https://d1z72rr1bj4jw1.cloudfront.net/campaign_cover_img/22_1635313047046_8f7bbe37-a19b-4ead-8c03-1ea673e19454.png'
          imageWidth:1125,
          imageHeight : 672,
          link: {
            mobileWebUrl: `https://plink.motiners.com/?link=${linkUrl}&apn=com.motiners.bundle&isi=1556370860&ibi=com.motiners.motinersapp`,
            webUrl: `https://plink.motiners.com/?link=${linkUrl}&apn=com.motiners.bundle&isi=1556370860&ibi=com.motiners.motinersapp`,
          },
        },
        buttons: [
          {
            title: '웹으로 보기',
            link: {
              mobileWebUrl: linkUrl,
              webUrl: linkUrl,
            },
          },
          {
            title: '앱으로 보기',
            link: { 
              mobileWebUrl: `https://plink.motiners.com/?link=${linkUrl}&apn=com.motiners.bundle&isi=1556370860&ibi=com.motiners.motinersapp`,
              webUrl: `https://plink.motiners.com/?link=${linkUrl}&apn=com.motiners.bundle&isi=1556370860&ibi=com.motiners.motinersapp`,
            },
          },
        ],
      })

      let stopInterval = setInterval(()=>{
        if(document.getElementById("kakao-link-btn").click)
        {
          document.getElementById("kakao-link-btn").click();
          clearInterval(stopInterval);
        }
      }, 200)

    }
  }
//style={{display:'none'}}
  return (
    <div onClick={handleClick} className="kakao-share-button" data-query-string={`${queryString}`}>
      {/* Kakao share button */}
      <span id="kakao-link-btn" ref={kakaoButton}></span>
    </div>
  )
}
export default KakaoShareButton